import { render, staticRenderFns } from "./_.vue?vue&type=template&id=87df20c2"
import script from "./_.vue?vue&type=script&lang=ts"
export * from "./_.vue?vue&type=script&lang=ts"
import style0 from "./_.vue?vue&type=style&index=0&id=87df20c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArticlePage: require('/app/components/contentTypes/ArticlePage.vue').default,LegalPage: require('/app/components/contentTypes/LegalPage.vue').default,NoCookiePage: require('/app/components/contentTypes/NoCookiePage.vue').default,Page: require('/app/components/contentTypes/Page.vue').default})
